<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Tramos Rutas</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Tramos Rutas</li>
                  <li class="breadcrumb-item active">
                    Formulario {{ accion }}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2 border-0">
                <div class="col-4 pt-2 pb-2">
                  <h5 class="mb-0">
                    Formulario {{ accion }} Tramos Rutas {{ id }}
                  </h5>
                </div>
              </div>
              <div class="card-body p-0">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a
                      class="nav-link active"
                      id="tab-Principal"
                      data-toggle="tab"
                      href="#Principal"
                      @click="cambiaTab('Principal')"
                      >Principal</a
                    >
                  </li>
                  <li class="nav-item" v-if="id">
                    <a
                      class="nav-link"
                      id="tab-Horarios"
                      data-toggle="tab"
                      href="#Horarios"
                      @click="cambiaTab('Horarios')"
                      >Horarios</a
                    >
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade active show" id="Principal">
                    <div class="card-body">
                      <div class="row justify-content-center">
                        <div
                          v-if="
                            accion === 'Crear' &&
                              $store.getters.can('plantaEx.tramosRutas.create')
                          "
                          class="col-md-2 d-flex align-items-center justify-content-center"
                        >
                          <label
                            class="card text-white rounded shadow p-3 d-flex flex-column align-items-center"
                            :class="
                              accion_coordenadas
                                ? 'bg-coordenadas'
                                : 'bg-secondary'
                            "
                          >
                            <div
                              class="form-check justify-content-center position-relative"
                            >
                              <input
                                v-model="accion_coordenadas"
                                @change="resetCoors"
                                type="checkbox"
                                id="accion_coordenadas"
                                class="form-check-input"
                              />

                              <label
                                for="accion_coordenadas"
                                class="form-check-label d-flex justify-content-center align-items-center p-1"
                              >
                                <i class="fas fa-compass text-white"></i>
                              </label>
                            </div>

                            <span
                              class="badge mt-2"
                              :class="
                                accion_coordenadas
                                  ? 'bg-light text-dark'
                                  : 'bg-dark'
                              "
                            >
                              Coordenadas
                            </span>
                          </label>
                        </div>
                        <div
                          v-if="
                            accion === 'Crear' &&
                              $store.getters.can('plantaEx.tramosRutas.create')
                          "
                          class="form-group col-md-5"
                        >
                          <div class="row">
                            <div class="col-md-12">
                              <h5>Origen</h5>
                            </div>
                            <div class="col-md-12">
                              <label class="mb-0">Buscar Origen:</label>
                              <gmap-autocomplete
                                v-if="!accion_coordenadas"
                                class="form-control form-control-sm"
                                @place_changed="setPlaceOrigen"
                                @keyup="onAddressInputChange"
                                :options="{
                                  fields: [
                                    'geometry',
                                    'formatted_address',
                                    'address_components',
                                  ],
                                }"
                              >
                                <template v-slot:input="slotProps">
                                  <v-text-field
                                    outlined
                                    prepend-inner-icon="place"
                                    placeholder="Introduce una ubicación"
                                    ref="inputOrigen"
                                    :error="
                                      $v.form.lat_origen.$invalid ||
                                        $v.form.lng_origen.$invalid
                                    "
                                    :error-messages="
                                      $v.form.lat_origen.$invalid ||
                                      $v.form.lng_origen.$invalid
                                        ? 'Este campo es obligatorio'
                                        : ''
                                    "
                                    v-bind="slotProps.attrs"
                                  >
                                  </v-text-field>
                                </template>
                              </gmap-autocomplete>
                              <div v-else>
                                <input
                                  v-model="coords.lat_origen"
                                  @blur="setCoordOrigen"
                                  type="text"
                                  placeholder="Latitud"
                                  class="form-control form-control-sm col-12 mb-1"
                                  :class="
                                    $v.form.lat_origen.$invalid
                                      ? 'is-invalid'
                                      : form.lat_origen
                                      ? 'is-valid'
                                      : ''
                                  "
                                />
                                <input
                                  v-model="coords.lng_origen"
                                  @blur="setCoordOrigen"
                                  type="text"
                                  placeholder="Longitud"
                                  class="form-control form-control-sm col-12 mb-1"
                                  :class="
                                    $v.form.lng_origen.$invalid
                                      ? 'is-invalid'
                                      : form.lng_origen
                                      ? 'is-valid'
                                      : ''
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="
                            accion === 'Crear' &&
                              $store.getters.can('plantaEx.tramosRutas.create')
                          "
                          class="form-group col-md-5"
                        >
                          <div class="row">
                            <div class="col-md-12">
                              <h5>Destino</h5>
                            </div>
                            <div class="col-md-12">
                              <label class="mb-0">Buscar Destino:</label>
                              <gmap-autocomplete
                                v-if="!accion_coordenadas"
                                class="form-control form-control-sm"
                                @place_changed="setPlaceDestino"
                                @keyup="onAddressInputChangeDestino"
                                :options="{
                                  fields: [
                                    'geometry',
                                    'formatted_address',
                                    'address_components',
                                  ],
                                }"
                              >
                                <template v-slot:input="slotProps">
                                  <v-text-field
                                    outlined
                                    prepend-inner-icon="place"
                                    placeholder="Introduce una ubicación"
                                    ref="inputDestino"
                                    :error="
                                      $v.form.lat_destino.$invalid ||
                                        $v.form.lng_destino.$invalid
                                    "
                                    :error-messages="
                                      $v.form.lat_destino.$invalid ||
                                      $v.form.lng_destino.$invalid
                                        ? 'Este campo es obligatorio'
                                        : ''
                                    "
                                    v-on:listeners="slotProps.listeners"
                                    v-on:attrs="slotProps.attrs"
                                  >
                                  </v-text-field>
                                </template>
                              </gmap-autocomplete>
                              <div v-else>
                                <input
                                  v-model="coords.lat_destino"
                                  @blur="setCoordDestino"
                                  type="text"
                                  placeholder="Latitud"
                                  class="form-control form-control-sm col-12 mb-1"
                                  :class="
                                    $v.form.lat_destino.$invalid
                                      ? 'is-invalid'
                                      : form.lat_destino
                                      ? 'is-valid'
                                      : ''
                                  "
                                />
                                <input
                                  v-model="coords.lng_destino"
                                  @blur="setCoordDestino"
                                  type="text"
                                  placeholder="Longitud"
                                  class="form-control form-control-sm col-12 mb-1"
                                  :class="
                                    $v.form.lng_destino.$invalid
                                      ? 'is-invalid'
                                      : form.lng_destino
                                      ? 'is-valid'
                                      : ''
                                  "
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="form-group col-md-5"
                          v-if="accion === 'Editar'"
                        >
                          <div class="row">
                            <div class="col-md-12">
                              <h5>Origen</h5>
                            </div>
                            <div class="col-md-6">
                              <label>Latitud</label>
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Latitud Origen"
                                v-model="form.lat_origen"
                                :class="
                                  $v.form.lat_origen.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                              />
                            </div>
                            <div class="col-md-6">
                              <label>Longitud</label>
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Longitud Origen"
                                v-model="form.lng_origen"
                                :class="
                                  $v.form.lng_origen.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          class="form-group col-md-5"
                          v-if="accion === 'Editar'"
                        >
                          <div class="row">
                            <div class="col-md-12">
                              <h5>Destino</h5>
                            </div>
                            <div class="col-md-6">
                              <label>Latitud</label>
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Latitud Destino"
                                v-model="form.lat_destino"
                                :class="
                                  $v.form.lat_destino.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                              />
                            </div>
                            <div class="col-md-6">
                              <label>Longitud</label>
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Longitud Destino"
                                v-model="form.lng_destino"
                                :class="
                                  $v.form.lng_destino.$invalid
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                              />
                            </div>
                          </div>
                        </div>
                        <div class="form-group col-md-5">
                          <label>Nombre</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            placeholder="Nombre"
                            v-model="form.nombre"
                            :class="
                              $v.form.nombre.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                        <div class="form-group col-md-5">
                          <label>Velocidad Máxima</label>
                          <input
                            type="number"
                            class="form-control form-control-sm"
                            placeholder="Velocidad Máxima"
                            v-model="form.vel_max"
                            :class="
                              $v.form.vel_max.$invalid
                                ? 'is-invalid'
                                : 'is-valid'
                            "
                          />
                        </div>
                        <div class="form-group col-md-5">
                          <label>Color</label>

                          <input
                            type="color"
                            v-model="form.color"
                            class="form-control form-control-sm"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0" v-if="id">
                      <TramosRutasDetalle
                        ref="TramosRutasDetalle"
                      ></TramosRutasDetalle>
                    </div>
                  </div>
                  <div class="tab-pane fade" id="Horarios" v-if="id">
                    <div class="card-body">
                      <div
                        class="d-flex justify-content-between align-items-center mb-4"
                      >
                        <h6 class="mb-0">
                          <i class="far fa-clock text-primary mr-2"></i>
                          <strong>Horarios Permitidos de Tránsito</strong>
                        </h6>
                        <button
                          class="btn btn-sm btn-outline-primary"
                          @click="saveHorarios()"
                          title="Guardar solo los horarios"
                        >
                          <i class="fas fa-save mr-1"></i> Guardar Horarios
                        </button>
                      </div>
                      <div class="mb-3 p-3 bg-light rounded">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="replicarHorarios"
                            v-model="replicarHorarios"
                            @change="aplicarReplicacion"
                            :disabled="!hayDiaConHorarios"
                          />
                          <label
                            class="form-check-label font-weight-bold"
                            for="replicarHorarios"
                          >
                            Replicar horario
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="card-body pt-0 table-responsive">
                      <table
                        id="tablaHorarios"
                        class="table table-hover align-middle table-bordered"
                        v-if="form1.length === ListasForm.dias_semana.length"
                      >
                        <thead class="bg-coordenadas text-white">
                          <tr>
                            <th class="bg-light text-center"></th>
                            <th
                              v-for="(dias, index) in ListasForm.dias_semana"
                              :key="index"
                              class="text-center align-middle position-relative"
                            >
                              <div
                                class="d-flex flex-column align-items-center justify-content-center"
                                style="min-height: 60px;"
                              >
                                <div
                                  class="position-relative mb-2"
                                  style="width: 20px; height: 20px;"
                                >
                                  <input
                                    v-if="form1[index]"
                                    class="form-check-input position-absolute top-0 start-0 m-0"
                                    type="checkbox"
                                    :id="`datos_dia_${index}`"
                                    v-model="form1[index].datos_dia"
                                  />
                                </div>
                                <label
                                  class="form-check-label mb-0 text-center w-100 d-block"
                                  :for="`datos_dia_${index}`"
                                >
                                  {{ dias.descripcion }}
                                </label>
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td class="bg-light text-center">
                              <span><strong>Inicio</strong></span>
                            </td>

                            <td
                              v-for="(horario_ini, index) in form1"
                              :key="index"
                              class="p-2"
                            >
                              <input
                                type="time"
                                class="form-control"
                                v-model="horario_ini.horario_ini"
                                :disabled="!horario_ini.datos_dia"
                                :class="
                                  !horario_ini.horario_ini
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                              />
                            </td>
                          </tr>

                          <tr>
                            <td class="bg-light text-center">
                              <span><strong>Fin</strong></span>
                            </td>

                            <td
                              v-for="(horario_fin, index) in form1"
                              :key="index"
                              class="p-2"
                            >
                              <input
                                type="time"
                                class="form-control"
                                v-model="horario_fin.horario_fin"
                                :disabled="!horario_fin.datos_dia"
                                :class="
                                  !horario_fin.horario_fin
                                    ? 'is-invalid'
                                    : 'is-valid'
                                "
                              />
                            </td>
                          </tr>

                          <tr>
                            <td class="bg-light text-center">
                              <span>
                                <strong>Observación</strong>
                              </span>
                            </td>

                            <td
                              v-for="(observacion, index) in form1"
                              :key="index"
                              class="p-2"
                            >
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                v-model="observacion.observacion"
                                :disabled="!observacion.datos_dia"
                                placeholder="Observación"
                              />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="d-flex gap-2">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="back()"
                    >
                      <i class="fas fa-reply"></i> Volver
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="save()"
                      v-if="
                        !$v.form.$invalid &&
                          ($store.getters.can('plantaEx.tramosRutas.edit') ||
                            $store.getters.can('plantaEx.tramosRutas.create'))
                      "
                    >
                      <i class="fas fa-paper-plane"> Guardar</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import { required } from "vuelidate/lib/validators";
import TramosRutasDetalle from "./TramosRutasDetalle.vue";

export default {
  name: "PlantTramosRutasForm",
  components: {
    Loading,
    TramosRutasDetalle,
  },
  data() {
    return {
      cargando: false,
      id: null,
      accion: "",
      form: {},
      tramoRuta: {},
      ListasForm: {
        dias_semana: [],
      },
      form1: [],
      replicarHorarios: false,
      accion_coordenadas: false,
      coords: {
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
      },
      markers: {
        inicio_tramo_ruta: null,
        fin_tramo_ruta: null,
        tramo_ruta: {
          path: [],
          options: {
            strokeColor: "#00529c",
            strokeOpacity: "0.9",
            strokeWeight: 5,
          },
        },
        waypoints: [],
      },
    };
  },

  validations: {
    form: {
      nombre: {
        required,
      },
      vel_max: {
        required,
      },
      lat_origen: {
        required,
      },
      lng_origen: {
        required,
      },
      lat_destino: {
        required,
      },
      lng_destino: {
        required,
      },
    },
  },

  computed: {
    hayDiaConHorarios() {
      return this.form1.some((dia) => dia.horario_ini && dia.horario_fin);
    },
  },

  watch: {
    hayDiaConHorarios(newVal) {
      // Si no hay días con horarios, desmarcar el checkbox de replicar
      if (!newVal && this.replicarHorarios) {
        this.replicarHorarios = false;
      }
    },
  },

  methods: {
    // Helper method to check if Google Maps is loaded
    isGoogleMapsLoaded() {
      return (
        typeof window !== "undefined" &&
        window.google &&
        window.google.maps &&
        window.google.maps.DirectionsService
      );
    },

    getIndex() {
      this.id = this.$route.params.id;
      this.accion = this.$route.params.accion;

      if (this.accion === "Crear") {
        this.accion_coordenadas = false;
        this.coords = {
          lat_origen: null,
          lng_origen: null,
          lat_destino: null,
          lng_destino: null,
        };
      }

      this.form = {
        nombre: null,
        ubicacion: null,
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
        observacion: null,
        vel_max: null,
        color: "#00529c",
        estado: 1,
      };

      if (this.accion === "Editar") {
        this.cargando = true;
        axios
          .get("/api/plant/tramosRutas/" + this.id)
          .then((response) => {
            this.cargando = false;
            this.form = response.data;
            this.tramoRuta = response.data;
            this.buildArrays(this.tramoRuta);

            // Inicializar markers del formulario principal con las coordenadas del tramo
            if (this.form.lat_origen && this.form.lng_origen) {
              this.markers.inicio_tramo_ruta = {
                position: {
                  lat: parseFloat(this.form.lat_origen),
                  lng: parseFloat(this.form.lng_origen),
                },
              };
            }

            if (this.form.lat_destino && this.form.lng_destino) {
              this.markers.fin_tramo_ruta = {
                position: {
                  lat: parseFloat(this.form.lat_destino),
                  lng: parseFloat(this.form.lng_destino),
                },
              };
            }

            this.$refs.TramosRutasDetalle.getIndex();
          })
          .catch((error) => {
            this.cargando = false;
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    async getDiasSemana() {
      await axios.get("/api/lista/90").then((response) => {
        this.ListasForm.dias_semana = response.data;
      });
    },

    buildArrays(tramoRuta = null) {
      this.form1 = [];
      this.metodo = tramoRuta && tramoRuta.horarios ? "PUT" : "POST";

      // Asegurar que ListasForm.dias_semana esté inicializado
      if (
        !this.ListasForm.dias_semana ||
        this.ListasForm.dias_semana.length === 0
      ) {
        return;
      }

      this.ListasForm.dias_semana.forEach((dia, index) => {
        this.form1.push({
          id: null,
          tramo_ruta_id: this.id,
          dia_semana: dia.numeracion,
          horario_ini: null,
          horario_fin: null,
          observacion: null,
          datos_dia: false,
        });
        if (
          tramoRuta &&
          tramoRuta.horarios &&
          tramoRuta.horarios.find(
            (tramo) => tramo.dia_semana === dia.numeracion
          )
        ) {
          const horario = tramoRuta.horarios.find(
            (tramo) => tramo.dia_semana === dia.numeracion
          );
          if (horario && this.form1[index]) {
            this.form1[index] = {
              id: horario.id,
              tramo_ruta_id: this.id,
              dia_semana: horario.dia_semana,
              horario_ini: horario.horario_ini,
              horario_fin: horario.horario_fin,
              observacion: horario.observacion,
              datos_dia: true,
            };
          }
        }
      });
    },

    cambiaTab(tab) {
      this.tab = tab;
    },

    resetCoors() {
      this.coords = {
        lat_origen: null,
        lng_origen: null,
        lat_destino: null,
        lng_destino: null,
      };
      // Limpiar también los campos del form cuando se cambia el modo
      if (this.accion === "Crear") {
        this.form.lat_origen = null;
        this.form.lng_origen = null;
        this.form.lat_destino = null;
        this.form.lng_destino = null;
        this.markers.inicio_tramo_ruta = null;
        this.markers.fin_tramo_ruta = null;
        this.markers.tramo_ruta.path = [];
      }
    },

    onAddressInputChange(valueOrEvent) {
      // Extraer el valor correctamente
      const newValue =
        typeof valueOrEvent === "string"
          ? valueOrEvent
          : valueOrEvent?.target?.value || "";

      if (!newValue || newValue.trim() === "") {
        this.form.lat_origen = null;
        this.form.lng_origen = null;
        this.markers.inicio_ruta = null;
        if (this.markers.tramo_ruta?.path?.length > 0) {
          this.markers.tramo_ruta.path.shift();
        }
      }
    },

    onAddressInputChangeDestino(valueOrEvent) {
      // Extraer el valor correctamente
      const newValue =
        typeof valueOrEvent === "string"
          ? valueOrEvent
          : valueOrEvent?.target?.value || "";

      if (!newValue || newValue.trim() === "") {
        this.form.lat_destino = null;
        this.form.lng_destino = null;
        this.markers.fin_tramo_ruta = null;
        if (this.markers.tramo_ruta?.path?.length > 1) {
          this.markers.tramo_ruta.path.pop();
        }
      }
    },

    setPlaceOrigen(place) {
      const lat = parseFloat(place.geometry.location.lat());
      const lng = parseFloat(place.geometry.location.lng());

      this.form.lat_origen = lat;
      this.form.lng_origen = lng;

      this.markers.inicio_tramo_ruta = {
        position: {
          lat: lat,
          lng: lng,
        },
      };

      if (this.markers.tramo_ruta.path.length === 0) {
        this.markers.tramo_ruta.path.push({
          lat: lat,
          lng: lng,
        });
      } else {
        this.markers.tramo_ruta.path[0] = {
          lat: lat,
          lng: lng,
        };
      }

      this.calcularRuta();
    },

    setPlaceDestino(place) {
      const lat = parseFloat(place.geometry.location.lat());
      const lng = parseFloat(place.geometry.location.lng());

      this.form.lat_destino = lat;
      this.form.lng_destino = lng;

      this.markers.fin_tramo_ruta = {
        position: {
          lat: lat,
          lng: lng,
        },
      };

      if (this.markers.tramo_ruta.path.length > 1) {
        this.markers.tramo_ruta.path[
          this.markers.tramo_ruta.path.length - 1
        ] = {
          lat: lat,
          lng: lng,
        };
      } else {
        this.markers.tramo_ruta.path.push({
          lat: lat,
          lng: lng,
        });
      }
      this.calcularRuta();
    },

    setCoordOrigen() {
      if (this.coords.lat_origen && this.coords.lng_origen) {
        const lat = parseFloat(this.coords.lat_origen);
        const lng = parseFloat(this.coords.lng_origen);

        this.form.lat_origen = lat;
        this.form.lng_origen = lng;

        this.markers.inicio_tramo_ruta = {
          position: {
            lat: lat,
            lng: lng,
          },
        };

        if (this.markers.tramo_ruta.path.length === 0) {
          this.markers.tramo_ruta.path.push({
            lat: lat,
            lng: lng,
          });
        } else {
          this.markers.tramo_ruta.path[0] = {
            lat: lat,
            lng: lng,
          };
        }

        if (this.markers.fin_tramo_ruta) {
          this.calcularRuta();
        }
      }
    },

    setCoordDestino() {
      if (this.coords.lat_destino && this.coords.lng_destino) {
        const lat = parseFloat(this.coords.lat_destino);
        const lng = parseFloat(this.coords.lng_destino);

        this.form.lat_destino = lat;
        this.form.lng_destino = lng;

        this.markers.fin_tramo_ruta = {
          position: {
            lat: lat,
            lng: lng,
          },
        };

        if (this.markers.tramo_ruta.path.length > 1) {
          this.markers.tramo_ruta.path[
            this.markers.tramo_ruta.path.length - 1
          ] = {
            lat: lat,
            lng: lng,
          };
        } else {
          this.markers.tramo_ruta.path.push({
            lat: lat,
            lng: lng,
          });
        }
        this.calcularRuta();
      }
    },

    async calcularRuta() {
      if (!this.markers.inicio_tramo_ruta || !this.markers.fin_tramo_ruta) {
        return;
      }

      // Verificar que Google Maps esté cargado
      if (!this.isGoogleMapsLoaded()) {
        console.warn("Google Maps no está cargado aún, esperando...");
        // Esperar un poco y reintentar
        await new Promise((resolve) => setTimeout(resolve, 500));
        if (!this.isGoogleMapsLoaded()) {
          console.error("Google Maps no está disponible");
          this.cargando = false;
          // Crear un path simple entre origen y destino como fallback
          if (this.markers.inicio_tramo_ruta && this.markers.fin_tramo_ruta) {
            this.markers.tramo_ruta.path = [
              this.markers.inicio_tramo_ruta.position,
              this.markers.fin_tramo_ruta.position,
            ];
          }
          return;
        }
      }

      this.cargando = true;
      try {
        const directionsService = new window.google.maps.DirectionsService();
        const request = {
          origin: this.markers.inicio_tramo_ruta.position,
          destination: this.markers.fin_tramo_ruta.position,
          waypoints: this.markers.waypoints || [],
          travelMode: window.google.maps.TravelMode.DRIVING,
        };

        const result = await new Promise((resolve, reject) => {
          directionsService.route(request, (res, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              resolve(res);
            } else {
              reject(new Error(status));
            }
          });
        });

        let distanciaMetros = 0;
        const allCoordinates = [];
        result.routes.forEach((route) => {
          route.legs.forEach((leg) => {
            distanciaMetros += leg.distance.value;
            leg.steps.forEach((stp) => {
              const stepCoordinates = stp.path.map((element) => ({
                lat: element.lat(),
                lng: element.lng(),
              }));
              allCoordinates.push(...stepCoordinates);
            });
          });
        });

        this.distancia_tramo_ruta =
          distanciaMetros > 0
            ? (distanciaMetros / 1000).toFixed(3)
            : "0.000";

        if (allCoordinates.length > 0) {
          const tolerance = 0.00025;
          this.markers.tramo_ruta.path = this.simplifyPolyline(
            allCoordinates,
            tolerance
          );
        } else if (
          this.markers.inicio_tramo_ruta &&
          this.markers.fin_tramo_ruta
        ) {
          this.markers.tramo_ruta.path = [
            this.markers.inicio_tramo_ruta.position,
            this.markers.fin_tramo_ruta.position,
          ];
        }
      } catch (e) {
        this.$swal({
          icon: "warning",
          title:
            "No se pudo cargar la ruta: Google Maps, no cuenta con la ruta disponible para este origen y destino (" +
            (e.message || e) +
            ")",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        if (this.markers.inicio_tramo_ruta && this.markers.fin_tramo_ruta) {
          this.markers.tramo_ruta.path = [
            this.markers.inicio_tramo_ruta.position,
            this.markers.fin_tramo_ruta.position,
          ];
        }
      } finally {
        this.cargando = false;
      }
    },

    // Función para calcular la distancia perpendicular entre un punto y una línea
    perpendicularDistance(point, lineStart, lineEnd) {
      let x = point.lat;
      let y = point.lng;
      let x1 = lineStart.lat;
      let y1 = lineStart.lng;
      let x2 = lineEnd.lat;
      let y2 = lineEnd.lng;

      let numerator = Math.abs(
        (y2 - y1) * x - (x2 - x1) * y + x2 * y1 - y2 * x1
      );
      let denominator = Math.sqrt(Math.pow(y2 - y1, 2) + Math.pow(x2 - x1, 2));

      return denominator === 0 ? 0 : numerator / denominator;
    },

    // Algoritmo Douglas-Peucker
    douglasPeucker(points, tolerance) {
      if (points.length < 3) {
        return points;
      }

      let maxDistance = 0;
      let index = 0;
      let startPoint = points[0];
      let endPoint = points[points.length - 1];

      for (let i = 1; i < points.length - 1; i++) {
        let distance = this.perpendicularDistance(
          points[i],
          startPoint,
          endPoint
        );
        if (distance > maxDistance) {
          index = i;
          maxDistance = distance;
        }
      }

      if (maxDistance > tolerance) {
        let left = this.douglasPeucker(points.slice(0, index + 1), tolerance);
        let right = this.douglasPeucker(points.slice(index), tolerance);

        return left.slice(0, left.length - 1).concat(right);
      } else {
        return [startPoint, endPoint];
      }
    },

    // Función para simplificar la polilínea
    simplifyPolyline(points, tolerance) {
      if (!points || points.length === 0) return [];
      return this.douglasPeucker(points, tolerance);
    },

    aplicarReplicacion() {
      if (
        this.replicarHorarios &&
        this.form1.length > 0 &&
        this.hayDiaConHorarios
      ) {
        // Buscar el primer día que tenga horarios configurados
        let diaOrigen = null;
        for (let i = 0; i < this.form1.length; i++) {
          if (this.form1[i].horario_ini && this.form1[i].horario_fin) {
            diaOrigen = this.form1[i];
            break;
          }
        }

        // Si no hay ningún día con horarios, no hacer nada
        if (!diaOrigen) {
          this.replicarHorarios = false;
          return;
        }

        // Replicar el horario a todos los días
        this.form1.forEach((dia, index) => {
          // No modificar el día origen si ya tiene datos
          if (dia !== diaOrigen) {
            dia.horario_ini = diaOrigen.horario_ini;
            dia.horario_fin = diaOrigen.horario_fin;
            dia.observacion = diaOrigen.observacion;
            // Activar el checkbox si el día origen tiene horarios
            if (diaOrigen.horario_ini && diaOrigen.horario_fin) {
              dia.datos_dia = true;
            }
          }
        });

        this.$swal({
          icon: "success",
          title: "Horarios replicados a todos los días",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    },

    saveHorarios() {
      this.cargando = true;
      axios({
        method: this.metodo,
        url: "/api/plant/tramosRutas/saveHorarios",
        data: this.form1,
      })
        .then(() => {
          this.cargando = false;
          this.getIndex();
          this.$swal({
            icon: "success",
            title: "Los horarios se han guardado exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo... " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    save() {
      this.cargando = true;

      // Actualizar coordenadas de origen y destino desde los markers si existen
      // Esto asegura que se usen las coordenadas más recientes del mapa cuando se crea
      if (this.accion === "Crear") {
        if (this.markers.inicio_tramo_ruta) {
          this.form.lng_origen = parseFloat(
            this.markers.inicio_tramo_ruta.position.lng
          );
          this.form.lat_origen = parseFloat(
            this.markers.inicio_tramo_ruta.position.lat
          );
        }

        if (this.markers.fin_tramo_ruta) {
          this.form.lng_destino = parseFloat(
            this.markers.fin_tramo_ruta.position.lng
          );
          this.form.lat_destino = parseFloat(
            this.markers.fin_tramo_ruta.position.lat
          );
        }
      }

      // Asegurar que los valores del form estén como números (tanto para crear como editar)
      if (this.form.lat_origen) {
        this.form.lat_origen = parseFloat(this.form.lat_origen);
      }
      if (this.form.lng_origen) {
        this.form.lng_origen = parseFloat(this.form.lng_origen);
      }
      if (this.form.lat_destino) {
        this.form.lat_destino = parseFloat(this.form.lat_destino);
      }
      if (this.form.lng_destino) {
        this.form.lng_destino = parseFloat(this.form.lng_destino);
      }

      if (this.accion === "Crear" && this.markers.tramo_ruta.path.length > 1) {
        this.form.path = this.markers.tramo_ruta.path;
        this.form.waypoints = JSON.stringify(this.markers.waypoints);
        this.form.distancia_km = parseFloat(this.distancia_tramo_ruta);
      }

      if (this.id) {
        this.form.distancia_km = parseFloat(
          this.$refs.TramosRutasDetalle.distancia_tramo_ruta
        );
      }

      // Asegurar que el ID esté presente cuando se edita
      if (this.id) {
        this.form.id = this.id;
      }

      // Usar PUT para editar y POST para crear
      const method = this.id ? "PUT" : "POST";

      axios({
        method: method,
        url: "/api/plant/tramosRutas",
        data: this.form,
      })
        .then(async (response) => {
          this.cargando = false;
          this.$route.params.id = await response.data.id;
          this.$route.params.accion = await "Editar";
          this.form = {};

          await this.getIndex();
          this.$swal({
            icon: "success",
            title: "Se guardó exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((error) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    back() {
      return this.$router.replace("/plantaExterna/TramosRutas");
    },
  },

  mounted() {
    this.getIndex();
  },

  async beforeMount() {
    await this.getDiasSemana();
    this.buildArrays();
  },
};
</script>
<style>
.bg-coordenadas {
  background: linear-gradient(to right, #c7123c, #303338) !important;
}
</style>
